import React from 'react'
import cx from 'classnames'
import IconSVG from 'svg-inline-react'
import { ProgressiveLoader } from '@driftt/tide-core-legacy'

import {
  PLACEHOLDER_PRIMARY_COLOR,
  PLACEHOLDER_SECONDARY_COLOR,
  PLACEHOLDER_PRIMARY_OPACITY,
  PLACEHOLDER_SECONDARY_OPACITY,
} from 'components/conversation/ContactSideBar'

import boltIconSrc from '!svg-inline?removeTags=true!images/svg/cql_bolt.svg'
import minusIconSrc from '!svg-inline?removeTags=true!images/svg/minus.svg'

import './style.styl'

const CQLBar = ({ score, onClick, isPlaceholder }) => {
  if (isPlaceholder) {
    const placeholderShape = <rect x="0" y="0" width="229" height="27" rx="2" />

    const options = {
      height: 27,
      width: 229,
      primaryColor: PLACEHOLDER_PRIMARY_COLOR,
      secondaryColor: PLACEHOLDER_SECONDARY_COLOR,
      primaryOpacity: PLACEHOLDER_PRIMARY_OPACITY,
      secondaryOpacity: PLACEHOLDER_SECONDARY_OPACITY,
    }

    return (
      <div className="conversation-cql-bar-container placeholder">
        <ProgressiveLoader options={options} placeholderShape={placeholderShape} numPlaceholders={1} />
      </div>
    )
  }

  return (
    <div className="conversation-cql-bar-container">
      <div className="conversation-cql-bar-title">mark as cql</div>
      <div className="conversation-cql-bar">
        <div
          is
          onClick={onClick(-1)}
          class={cx('conversation-cql-bar-option', 'cql-bar-unqualified', { selected: score === -1 })}
          flow="up"
          tooltip="Unqualified"
        >
          <IconSVG className="conversation-cql-bar-minus-icon" src={minusIconSrc} />
        </div>
        <div
          is
          onClick={onClick(1)}
          class={cx('conversation-cql-bar-option', 'cql-bar-good', { selected: score === 1 })}
          flow="up"
          tooltip="Good CQL"
        >
          <IconSVG className="conversation-cql-bar-bolt-icon" src={boltIconSrc} />
        </div>
        <div
          is
          onClick={onClick(2)}
          class={cx('conversation-cql-bar-option', 'cql-bar-better', { selected: score === 2 })}
          flow="up"
          tooltip="Better CQL"
        >
          <IconSVG className="conversation-cql-bar-bolt-icon" src={boltIconSrc} />
          <IconSVG className="conversation-cql-bar-bolt-icon" src={boltIconSrc} />
        </div>
        <div
          is
          onClick={onClick(3)}
          class={cx('conversation-cql-bar-option', 'cql-bar-best', { selected: score === 3 })}
          flow="up"
          tooltip="Best CQL"
        >
          <IconSVG className="conversation-cql-bar-bolt-icon" src={boltIconSrc} />
          <IconSVG className="conversation-cql-bar-bolt-icon" src={boltIconSrc} />
          <IconSVG className="conversation-cql-bar-bolt-icon" src={boltIconSrc} />
        </div>
      </div>
    </div>
  )
}

export default CQLBar



// WEBPACK FOOTER //
// ./src/scripts/components/conversation/ContactSideBar/Person/CQLBar/component.js